export const localizedSupportPaths = {
  '/media-kit': {
    en: '/en/media-kit',
    it: '/it/kit-multimediale',
    de: '/de/medien-kit'
  },
  '/whats-new': {
    en: '/en/whats-new',
    it: '/it/novita',
    de: '/de/was-gibt-es-neues'
  },
  '/api-and-integrations': {
    en: '/en/api-and-integrations',
    it: '/it/api-e-integrazioni',
    de: '/de/api-und-integrationen'
  }
} as const

export type SupportPath = keyof typeof localizedSupportPaths

const localizedSupportLanguages = ['en', 'it', 'de'] as const
type LocalizedSupportLanguage = (typeof localizedSupportLanguages)[number]

const isLocalizedSupportLanguage = (language: string): language is LocalizedSupportLanguage =>
  localizedSupportLanguages.includes(language as LocalizedSupportLanguage)

export const getLocalizedSupportUrl = (language: string, path?: SupportPath) => {
  const baseUrl = 'https://support.laratranslate.com'

  const isSupportedLanguage = isLocalizedSupportLanguage(language)
  const localizedLanguage = isSupportedLanguage ? language : 'en'

  const localizedPath = path
    ? localizedSupportPaths[path]?.[localizedLanguage]
    : `/${localizedLanguage}`

  return {isLocalized: isSupportedLanguage, url: `${baseUrl}${localizedPath}`}
}
